import { FormLabel, InputGroup } from '@/components'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { FormControl } from '@chakra-ui/react'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'

export const AdditionalPropertyInfoDirect = () => {
  const { insuranceParams } = useInsuranceParams()

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, formState: { errors }, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const appartmentNrRequired = getValues('property.additionalDataDirect.appartmentNumberRequired')

  return (
    <>
      {appartmentNrRequired &&
                <FormControl isRequired isInvalid={!!errors.property?.additionalDataDirect?.appartmentNumber}>
                  <FormLabel>Číslo bytu</FormLabel>
                  <InputGroup
                    isDisabled={isContracted}
                    id="appartmentNumber"
                    htmlSize={8}
                    autoComplete="off"
                    errors={errors.property?.additionalDataDirect?.appartmentNumber}
                    {...register('property.additionalDataDirect.appartmentNumber')}
                  />
                </FormControl>
      }
    </>
  )
}
